import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ArrowUpRight } from 'lucide-react';

const CODE_OF_CONDUCT_URL =
  'https://www.tataautocomp.com/wp-content/uploads/2026/04/TataCodeOfConduct.pdf';

const CodeOfConduct = () => {
  const { t } = useLanguage();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });

  return (
    <section id="code-of-conduct" ref={ref} className="py-16 md:py-20 bg-muted/40">
      <div className="container-tight">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center border border-[hsl(var(--hairline))] rounded-xl bg-background px-8 py-10 md:px-12 md:py-12"
        >
          <div className="lg:col-span-8">
            <span className="eyebrow mb-4 block">{t('conduct.badge')}</span>
            <h2 className="font-display font-bold text-primary mb-4" style={{ fontSize: 'clamp(1.5rem, 2.5vw, 2rem)', lineHeight: 1.1 }}>
              {t('conduct.title')}
            </h2>
            <p className="text-foreground/75 leading-relaxed max-w-2xl">
              {t('conduct.description')}
            </p>
          </div>

          <div className="lg:col-span-4 flex flex-col items-start lg:items-end gap-3">
            <a
              href={CODE_OF_CONDUCT_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group btn-primary inline-flex items-center gap-2"
            >
              {t('conduct.cta')}
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <Link to="/whistleBlower" className="btn-secondary">
              {t('conduct.whistle')}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CodeOfConduct;
